
// 引用axios
var axios = require('axios');
import { MessageBox, Message } from 'element-ui'
function apiAxios (method, url, params, success, failure) {
  let CancelToken = axios.CancelToken;
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    timeout:5000,
    withCredentials: false,
    cancelToken: new CancelToken(function executor(c) {
      window.Vue.cancel = c
      // 这个参数 c 就是CancelToken构造函数里面自带的取消请求的函数，这里把该函数当参数用
    })
  })
  .then(function (res) {
    success(res.data)
  })
  .catch(function (err) {
    let res = err;
    if (err) {
      // window.alert('error: ' + res)
    }
  })
}

axios.interceptors.request.use(
  config => {
    // if (window.Vue.$common.getCookie('tibiot-personal-card')) {
    //   // 每次发请求，请求头带token
    //   config.headers.Authorization = window.Vue.$common.getCookie('tibiot-personal-card');
    // }
    return config;
  },
  err => {
    return Promise.reject(err);
  });
  let lateFlag = 0;

    // 错误提示
  axios.interceptors.response.use(
    response => {
      if (response.data.code == 401) {
          // document.cookie='tibiot-personal-card='+ window.Vue.$common.getCookie('tibiot-personal-card') + ';path=/;expires=Thu,01 Jan 1970 00:00:00 GMT'; // 退出清除token cookie
          // window.localStorage.removeItem("vuex-along");//清除vue-along
          // window.Vue.$router.push("/login");
          // if(lateFlag == 0){
          //   lateFlag++
          //   MessageBox.confirm( "您已长时间未操作平台，请重新登录!",'重新登录', {
          //     confirmButtonText: '确定',
          //     showCancelButton: false,
          //     roundButton: true,
          //     type: 'warning'
          //   }).then(() => {
          //     lateFlag = 0;
          //   });
          // }
      }
      return response;
    },
    error => {
        if (error.response) {
          switch (error.response.status) {
            case 401:
              // window.Vue.$router.push("/login");
              break;
          }
        }
        return Promise.reject(error)
      // return Promise.reject(error.response.data)
    });

// 返回在vue模板中的调用接口
export default {
  get: function (url, params, success, failure) {
    return apiAxios('GET', url, params, success, failure)
  },
  post: function (url, params, success, failure) {
    return apiAxios('POST', url, params, success, failure)
  },
  put: function (url, params, success, failure) {
    return apiAxios('PUT', url, params, success, failure)
  },
  delete: function (url, params, success, failure) {
    return apiAxios('DELETE', url, params, success, failure)
  }
}



// WEBPACK FOOTER //
// ./src/assets/axios_api/index.js